import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
// import Vacancies from '@/components/Vacancies';
import Company from '@/components/Company';
import CompanyHistory from '@/components/CompanyHistory';
import CompanyBrands from '@/components/CompanyBrands';
import CompanyValues from '@/components/CompanyValues';
import CompanyPlans from '@/components/CompanyPlans';
import Advantages from '@/components/Advantages';
import Space from '@/components/Space';
import SpaceOffice from '@/components/SpaceOffice';
// import SpacePeople from '@/components/SpacePeople';
import Contacts from '@/components/Contacts';
// import Vacancy from '@/components/Vacancy';
import Request from '@/components/Request';
import Documents from '@/components/Documents';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    /*
    {
        path: '/vacancies',
        name: 'Vacancies',
        component: Vacancies,
        props: true
    },
    {
        path: '/vacancy/:vacancyId',
        name: 'Vacancy',
        component: Vacancy,
        props: true
    },
    */
    {
      path: '/company',
      component: Company,
      redirect: { name: 'CompanyHistory' },
      children: [
        {
          path: 'history',
          name: 'CompanyHistory',
          component: CompanyHistory
        },
        {
          path: 'brands',
          name: 'CompanyBrands',
          component: CompanyBrands
        },
        {
          path: 'values',
          name: 'CompanyValues',
          component: CompanyValues
        },
        {
          path: 'plans',
          name: 'CompanyPlans',
          component: CompanyPlans
        }
      ]
    },
    {
      path: '/advantages',
      name: 'Advantages',
      component: Advantages
    },
    {
      path: '/space',
      component: Space,
      redirect: { name: 'SpaceOffice' },
      children: [
        {
          path: 'office',
          name: 'SpaceOffice',
          component: SpaceOffice
        }
        /* ,{
            path: 'people',
            name: 'SpacePeople',
            component: SpacePeople
        }, */
      ]
    },
    {
      path: '/documents',
      name: 'documents',
      component: Documents
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/request/:vacancyId',
      name: 'Request',
      component: Request,
      props: true
    },
    {
      path: '*',
      redirect: { name: 'Home' }
    }
  ]
});

export default router;
